import { useStoryblok, StoryblokComponent } from "@storyblok/react";
import { Layout } from "./components/layout";
import { LoadingComponent } from "./components/LoadingComponent";
import { getEnvironmentVersion } from "./utils/getEnvironmentVersion";
import { useParams } from "react-router-dom";
import { MetaTags } from "./components/MetaTags";

function App() {
  const { "*": slug } = useParams();

  const story = useStoryblok(slug || "home", {
    version: getEnvironmentVersion(),
    resolve_relations: [
      "featured-articles.articles",
      "featured-posts.blogposts",
    ],
  });

  return (
    <Layout>
      <MetaTags metatags={story?.content?.metatags} />
      <LoadingComponent loading={!story || !story.content}>
        <StoryblokComponent blok={story.content} />
      </LoadingComponent>
    </Layout>
  );
}

export default App;
